import type { TranslationKey } from '@/lib/i18n';

export const ANNOUNCEMENT_BAR_ACCESSIBILITY_REGION = [
  'common:announcementBar.region',
  'Announcement',
] as const satisfies TranslationKey;

export const ANNOUNCEMENT_BAR_ACCESSIBILITY_DISMISS = [
  'common:announcementBar.dismiss',
  'Dismiss announcement',
] as const satisfies TranslationKey;
